import { Component, computed, signal, inject, input, effect } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DialogNotificationSettings } from "../../dialogs/dialog-notification-settings/dialog-notification-settings";
import { MatDialog } from "@angular/material/dialog";
import { NotificationButtonModel } from "./notification-button.model";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "notification-button",
  templateUrl: "notification-button.html",
  styleUrls: ["notification-button.scss"],
  imports: [CommonModule, MatTooltipModule, AngularSvgIconModule],
})
export class NotificationButton {
  private translate = inject(TranslateService);
  private dialog = inject(MatDialog);

  subscription = input.required<NotificationButtonModel>();

  protected minImpact = signal("Loss of Resiliency");
  protected isActive = computed(() => this.minImpact() !== "Never");
  protected impactDescription = computed(() => this.impactDescriptions[this.minImpact()]);

  private impactDescriptions = {};

  constructor() {
    // TODO #190 the page sometimes loads faster than the translations
    const receiveNotificationsFor = this.translate.instant("Notification.ReceiveNotificationsFor");
    this.impactDescriptions = {
      Downtime: `${receiveNotificationsFor} ${this.translate.instant("Notification.Status.Downtime")}`,
      "Loss of Resiliency": `${receiveNotificationsFor} ${this.translate.instant(
        "Notification.Status.LossofResiliency",
      )}`,
      "Reduced Redundancy": `${receiveNotificationsFor} ${this.translate.instant(
        "Notification.Status.ReducedRedundancy",
      )}`,
      Never: `${receiveNotificationsFor} ${this.translate.instant("Notification.Status.Never")}`,
    };

    effect(() => {
      const minImpact = this.subscription().minimalImpactNotification ?? "Loss of Resiliency";
      this.minImpact.set(minImpact);
    });
  }

  openNotificationSettingsDialog() {
    const dialogRef = this.dialog.open(DialogNotificationSettings, {
      data: {
        subscriptionId: this.subscription().subscriptionId,
        name: this.subscription().description,
        impactSetting: this.minImpact(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // result is undefined when the window is closed without action.
      if (result) {
        this.minImpact.set(result.minimalImpactNotification);
      }
    });
  }
}
